/* Fransk katalog for locale-projects-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'pj.tab.time': 'Saisie des heures',
  'pj.tab.overview': 'Vue d\'ensemble',
  'pj.tab.settings': 'Paramètres',
  'pj.day.mon': 'Lun',
  'pj.day.tue': 'Mar',
  'pj.day.wed': 'Mer',
  'pj.day.thu': 'Jeu',
  'pj.day.fri': 'Ven',
  'pj.day.sat': 'Sam',
  'pj.day.sun': 'Dim',
  'pj.person.fallback': 'vous',
  'pj.time.title': 'Saisie des heures de {name}',
  'pj.week.label': 'Semaine {week}',
  'pj.week.word': 'Semaine',
  'pj.week.pick': 'Choisir la semaine',
  'pj.week.current': 'Cette semaine',
  'pj.week.back': 'Trois semaines en arrière',
  'pj.week.forward': 'Trois semaines en avant',
  'pj.week.prev': 'Semaine précédente',
  'pj.week.next': 'Semaine suivante',
  'pj.month.prev': 'Mois précédent',
  'pj.month.next': 'Mois suivant',
  'pj.month.entries': 'Heures saisies en {month}',
  'pj.month.dayHours': '{hours} saisies',
  'pj.view.day': 'Jour',
  'pj.view.week': 'Semaine',
  'pj.day.empty': 'Aucune heure saisie ce jour-là.',
  'pj.table.projectActivity': 'Projet / activité',
  'pj.table.sum': 'Total',
  'pj.table.hours': 'Heures',
  'pj.row.new': 'Nouvelle ligne',
  'pj.row.add': 'Ajouter',
  'pj.row.remove': 'Supprimer la ligne',
  'pj.row.pickBoth': 'Choisissez un projet et une activité',
  'pj.select.project': 'Choisir un projet …',
  'pj.select.activity': 'Choisir une activité …',
  'pj.select.projectSearch': 'Rechercher un projet …',
  'pj.select.activitySearch': 'Rechercher une activité …',
  'pj.select.projectEmpty': 'Aucun projet ne correspond à la recherche.',
  'pj.select.activityEmpty': 'Aucune activité ne correspond à la recherche.',
  'pj.project.createAction': 'Créer un nouveau projet',
  'pj.activity.createAction': 'Créer une nouvelle activité',
  'pj.activity.none': 'Ce projet n\'a pas encore d\'activités. Créez-en une ici.',
  'pj.lock.state.done': 'La saisie des heures est marquée comme terminée jusqu\'au {date} inclus.',
  'pj.lock.state.open': 'La saisie des heures n\'est pas marquée comme terminée',
  'pj.lock.markWeek': 'Marquer comme terminée jusqu\'à la semaine {week} incluse',
  'pj.lock.undo': 'Annuler',
  'pj.lock.done': 'La saisie des heures est marquée comme terminée jusqu\'à la semaine {week} incluse',
  'pj.lock.undone': 'La saisie des heures est rouverte',
  'pj.entry.newTitle': 'Nouvelle saisie d\'heures',
  'pj.entry.editTitle': 'Modifier la saisie d\'heures',
  'pj.entry.invoicedLocked': 'Ces heures sont facturées et ne peuvent pas être modifiées. Supprimez le brouillon de facture ou établissez un avoir pour les libérer.',
  'pj.entry.periodLocked': 'La saisie des heures de cette période est marquée comme terminée.',
  'pj.entry.invoicedShort': 'Facturé',
  'pj.field.project': 'Projet',
  'pj.field.activity': 'Activité',
  'pj.field.hours': 'Nombre d\'heures',
  'pj.field.date': 'Date',
  'pj.field.description': 'Description',
  'pj.field.descriptionHint': 'À quoi les heures ont-elles servi ? Le texte figure sur la facture.',
  'pj.field.name': 'Nom',
  'pj.field.number': 'Numéro',
  'pj.field.customer': 'Client',
  'pj.field.contact': 'Personne de contact',
  'pj.field.optional': 'Facultatif',
  'pj.field.defaultActivity': 'Activité par défaut',
  'pj.field.product': 'Produit',
  'pj.field.rate': 'Taux horaire',
  'pj.field.start': 'Début',
  'pj.field.end': 'Fin',
  'pj.field.color': 'Couleur',
  'pj.field.status': 'Statut',
  'pj.overview.title': 'Vue d\'ensemble des heures',
  'pj.overview.week': 'Vue hebdomadaire',
  'pj.overview.month': 'Vue mensuelle',
  'pj.overview.reports': 'Rapports',
  'pj.overview.total': 'Total saisi',
  'pj.overview.billable': '{hours} facturables',
  'pj.overview.weekEntries': 'Heures saisies en semaine {week}',
  'pj.overview.empty': 'Aucune heure saisie sur la période',
  'pj.overview.emptyTitle': 'Aucune heure',
  'pj.filter.all': 'Tous',
  'pj.filter.period': 'Période',
  'pj.filter.billing': 'Facturation',
  'pj.filter.billable': 'Facturable',
  'pj.filter.nonBillable': 'Non',
  'pj.filter.invoicedLabel': 'Facturé',
  'pj.filter.invoiced': 'Facturé',
  'pj.filter.open': 'Non facturé',
  'pj.report.title': 'Heures saisies {from} – {to}',
  'pj.report.emptyTitle': 'Aucune saisie',
  'pj.report.emptyText': 'Aucune heure pour la période et le filtre sélectionnés.',
  'pj.report.print': 'Imprimer',
  'pj.report.pdf': 'Télécharger en PDF',
  'pj.report.pdfTitle': 'Rapport des heures',
  'pj.report.pdfError': 'Impossible de télécharger le rapport.',
  'pj.report.pdfUnavailable': 'Le PDF du rapport n\'est pas connecté au backend.',
  'pj.report.opening': 'Ouverture de l\'impression …',
  'pj.basis.title': 'Base de facturation',
  'pj.basis.projectName': 'Nom du projet',
  'pj.basis.searchPlaceholder': 'Projet, client …',
  'pj.basis.summary': '{count} saisies non facturées du {from} au {to}',
  'pj.basis.selected': 'Sélectionné',
  'pj.basis.costs': 'Frais à refacturer',
  'pj.basis.costText': 'Frais',
  'pj.basis.costSource': 'Source',
  'pj.basis.costAmount': 'Montant',
  'pj.basis.costEmployee': 'Frais d\'employé · {name}',
  'pj.basis.costPurchase': 'Achat comptabilisé',
  'pj.basis.timesheet': 'Joindre une feuille de temps',
  'pj.basis.create': 'Créer un brouillon de facture',
  'pj.basis.created': 'Brouillon de facture créé pour {project}',
  'pj.basis.pickOne': 'Sélectionnez au moins une saisie',
  'pj.basis.error': 'Impossible de créer le brouillon de facture.',
  'pj.basis.emptyTitle': 'Aucune heure non facturée',
  'pj.basis.emptyText': 'Tout est facturé, ou aucune heure facturable n\'a encore été saisie sur des projets avec client.',
  'pj.cost.tab': 'Frais',
  'pj.cost.title': 'Frais de projet',
  'pj.cost.party': 'Employé / fournisseur',
  'pj.cost.voucher': 'Justificatif',
  'pj.cost.openVoucher': 'Voir le justificatif',
  'pj.cost.noVoucher': 'Le justificatif n\'est pas disponible',
  'pj.cost.noVoucherHelp': 'Aucun fichier n\'est associé à ce coût.',
  'pj.cost.noVoucherShort': 'Sans justificatif',
  'pj.cost.pending': 'En attente d\'approbation',
  'pj.cost.invoiced': 'Facturé',
  'pj.cost.notBillable': 'Non facturable',
  'pj.cost.toInvoice': 'À facturer',
  'pj.cost.searchLabel': 'Rechercher',
  'pj.cost.searchPlaceholder': 'Description, employé, fournisseur …',
  'pj.cost.openSum': '{amount} à facturer',
  'pj.cost.totalAll': 'Total de tous les résultats',
  'pj.cost.emptyTitle': 'Aucuns frais',
  'pj.cost.emptyText': 'Aucun coût n\'est encore associé à un projet. Les justificatifs sont associés à un projet dans la boîte de réception, sur l\'achat ou lorsque l\'employé soumet sa note de frais.',
  'pj.billing.always': 'Toujours',
  'pj.billing.ask': 'Demander',
  'pj.billing.never': 'Jamais',
  'pj.activity.newTitle': 'Nouvelle activité',
  'pj.activity.editTitle': 'Modifier l\'activité',
  'pj.activity.namePlaceholder': 'Ex. Conseil',
  'pj.activity.noProduct': 'Aucun',
  'pj.activity.productHint': 'Les heures sont facturées comme « {product} » et comptabilisées sur le compte {account}.',
  'pj.activity.noProductHint': 'Sans produit, les heures sont comptabilisées comme ventes de services sur le compte 3020 au taux de TVA standard.',
  'pj.activity.rateHint': 'HT. Si le champ est vide, le prix du produit est utilisé.',
  'pj.activity.neverHint': 'Les heures sont exclues de la base de facturation. Utilisez cette option pour les congés et le travail interne.',
  'pj.project.newTitle': 'Créer un nouveau projet',
  'pj.project.newShort': 'Nouveau projet',
  'pj.project.editTitle': 'Modifier le projet',
  'pj.project.numberHint': 'Suggestion : {number}',
  'pj.project.customerHint': 'Sans client, les heures ne peuvent pas être facturées.',
  'pj.project.noCustomer': 'Aucun client (projet interne)',
  'pj.project.closed': 'Clôturé',
  'pj.settings.title': 'Paramètres de saisie des heures',
  'pj.settings.activities': 'Activités',
  'pj.settings.projects': 'Projets',
  'pj.settings.noActivitiesTitle': 'Aucune activité pour l\'instant',
  'pj.settings.noActivitiesText': 'L\'activité détermine le taux horaire et le produit sous lequel les heures sont facturées.',
  'pj.settings.noProjectsFirst': 'Créez d\'abord un projet.',
  'pj.settings.noProjectsTitle': 'Aucun projet pour l\'instant',
  'pj.settings.noProjectsText': 'Créez un projet pour commencer à saisir des heures.',
  'pj.toast.entrySaved': 'Les heures sont enregistrées',
  'pj.toast.entryUpdated': 'La saisie d\'heures a été mise à jour',
  'pj.toast.entryDeleted': 'La saisie d\'heures a été supprimée',
  'pj.toast.activitySaved': 'L\'activité a été enregistrée',
  'pj.toast.activityDeleted': 'L\'activité a été supprimée',
  'pj.toast.projectSaved': 'Le projet a été enregistré',
  'pj.toast.projectDeleted': 'Le projet a été supprimé',
  'pj.error.saveEntry': 'Impossible d\'enregistrer la saisie d\'heures.',
  'pj.error.deleteEntry': 'Impossible de supprimer la saisie d\'heures.',
  'pj.error.saveRows': 'Impossible de mettre à jour les lignes.',
  'pj.error.lock': 'Impossible de mettre à jour le verrouillage.',
  'pj.error.saveActivity': 'Impossible d\'enregistrer l\'activité.',
  'pj.error.deleteActivity': 'Impossible de supprimer l\'activité.',
  'pj.error.saveProject': 'Impossible d\'enregistrer le projet.',
  'pj.error.deleteProject': 'Impossible de supprimer le projet.',
  'pj.validation.projectName': 'Le projet doit avoir un nom.',
  'pj.validation.endBeforeStart': 'La date de fin ne peut pas être antérieure à la date de début.',
  'pj.validation.activityName': 'L\'activité doit avoir un nom.',
  'pj.validation.activityProject': 'L\'activité doit appartenir à un projet.',
  'pj.validation.entryDate': 'La saisie d\'heures doit avoir une date.',
  'pj.validation.entryHours': 'Le nombre d\'heures doit être supérieur à 0.',
  'pj.validation.entryHoursMax': 'Une saisie ne peut pas dépasser 24 heures.',
  'pj.validation.entryNotFound': 'Saisie d\'heures introuvable.',
  'pj.validation.entryInvoiced': 'La saisie d\'heures est déjà facturée et ne peut pas être modifiée.',
  'pj.validation.periodLocked': 'La saisie des heures de cette période est marquée comme terminée.',
  'svc.projectNotFound': 'Projet introuvable.',
  'svc.projectNumberTaken': 'Ce numéro de projet est déjà utilisé.',
  'svc.projectHasHours': 'Des heures sont saisies sur ce projet. Marquez-le comme clôturé au lieu de le supprimer.',
  'svc.projectClosed': 'Le projet est clôturé et ne peut plus recevoir de nouvelles heures.',
  'svc.projectNeedsCustomer': 'Le projet doit avoir un client avant que les heures puissent être facturées.',
  'svc.activityNotFound': 'Activité introuvable.',
  'svc.activityHasHours': 'Des heures sont saisies sur cette activité, elle ne peut donc pas être supprimée.',
  'svc.timeEntryNotFound': 'Saisie d\'heures introuvable.',
  'svc.timeTrackingLocked': 'La saisie des heures de cette période est marquée comme terminée.',
  'svc.pickTimeEntries': 'Sélectionnez au moins une saisie d\'heures non facturée.',
  'svc.timesheetInvoiceDescription': 'Heures sur {project} pour la période {from} – {to}.',
});
